import React, { useState, useEffect } from 'react';
import {
  Container,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
  Alert,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Tooltip
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import MenuItem from '@mui/material/MenuItem';

const CaracteristicasMaquinas = () => {
  const [caracteristicas, setCaracteristicas] = useState([]);
  const [maquinas, setMaquinas] = useState([]);
  const [tiposMaquina, setTiposMaquina] = useState([]);
  const [open, setOpen] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [form, setForm] = useState({
    machineNumber: '',
    tipoMaquina: '',
    subtipoMaquina: '',
    potencia: '',
    proceso: '',
    modelo: '',
    tipoAguja1: '',
    origen1: '',
    cantidad1: '',
    tipoAguja2: '',
    origen2: '',
    cantidad2: '',
    tipoAguja3: '',
    origen3: '',
    cantidad3: '',
    tipoAguja4: '',
    origen4: '',
    cantidad4: '',
    diametro: '',
    marca: '',
    galga: '',
    caracteristicaAdicional: ''
  });

  // Cargar datos
  const fetchCaracteristicas = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      const response = await fetch('/api/caracteristicas-maquina', { headers });
      
      if (!response.ok) {
        if (response.status === 401) {
          setError('Sesión expirada. Por favor, inicia sesión nuevamente');
        } else if (response.status === 403) {
          setError('No tienes permisos para acceder a esta sección');
        } else {
          setError(`Error ${response.status}: ${response.statusText}`);
        }
        return;
      }
      
      const data = await response.json();
      // Ordenar por machineNumber numéricamente
      const sortedData = Array.isArray(data) ? data.sort((a, b) => {
        const numA = parseInt(a.machineNumber?.replace(/\D/g, '') || '0');
        const numB = parseInt(b.machineNumber?.replace(/\D/g, '') || '0');
        return numA - numB;
      }) : [];
      setCaracteristicas(sortedData);
    } catch (err) {
      console.error('Error al cargar características:', err);
      setError('Error al cargar las características: ' + err.message);
    }
  };

  const fetchMaquinas = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      const response = await fetch('/api/machines', { headers });
      
      if (response.ok) {
        const data = await response.json();
        setMaquinas(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      console.error('Error al cargar máquinas:', err);
    }
  };

  const fetchTiposMaquina = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      const response = await fetch('/api/tipos-maquina', { headers });
      
      if (response.ok) {
        const data = await response.json();
        setTiposMaquina(Array.isArray(data) ? data : []);
      }
    } catch (err) {
      console.error('Error al cargar tipos de máquina:', err);
    }
  };

  useEffect(() => {
    fetchCaracteristicas();
    fetchMaquinas();
    fetchTiposMaquina();
  }, []);

  const handleChange = async (field, value) => {
    // Si se cambia el número de máquina, cargar datos de tipomaquinas
    if (field === 'machineNumber' && value) {
      console.log('Buscando datos para máquina:', value);
      
      try {
        const token = localStorage.getItem('token');
        const headers = token ? { 'Authorization': `Bearer ${token}` } : {};
        
        const url = `/api/tipos-maquina/numero/${value}`;
        console.log('Haciendo petición a:', url);
        
        const response = await fetch(url, { headers });
        console.log('Respuesta status:', response.status);
        
        if (response.ok) {
          try {
            const responseText = await response.text();
            console.log('Texto de respuesta:', responseText);
            
            if (!responseText) {
              console.log('La respuesta está vacía');
              setForm({ ...form, [field]: value });
              return;
            }
            
            const tipoMaquinaData = JSON.parse(responseText);
            console.log('Datos recibidos:', tipoMaquinaData);
            console.log('tipoMaquina:', tipoMaquinaData.tipoMaquina);
            console.log('subtipoMaquina:', tipoMaquinaData.subtipoMaquina);
            console.log('potencia:', tipoMaquinaData.potencia);
            console.log('proceso:', tipoMaquinaData.proceso);
            
            // Actualizar todo el formulario de una sola vez
            setForm(prevForm => ({
              ...prevForm,
              machineNumber: value,
              tipoMaquina: tipoMaquinaData.tipoMaquina || '',
              subtipoMaquina: tipoMaquinaData.subtipoMaquina || '',
              potencia: tipoMaquinaData.potencia || '',
              proceso: tipoMaquinaData.proceso || ''
            }));
            console.log('Formulario actualizado');
          } catch (parseError) {
            console.error('Error al parsear respuesta:', parseError);
            setForm({ ...form, [field]: value });
          }
        } else {
          console.log('Error en la respuesta:', response.status);
          const errorData = await response.json();
          console.log('Error data:', errorData);
          setForm({ ...form, [field]: value });
        }
      } catch (err) {
        console.error('Error al cargar datos de tipo de máquina:', err);
        setForm({ ...form, [field]: value });
      }
    } else {
      // Para cualquier otro campo, actualizar normalmente
      setForm({ ...form, [field]: value });
    }
  };

  const resetForm = () => {
    setForm({
      machineNumber: '',
      tipoMaquina: '',
      subtipoMaquina: '',
      potencia: '',
      proceso: '',
      modelo: '',
      tipoAguja1: '',
      origen1: '',
      cantidad1: '',
      tipoAguja2: '',
      origen2: '',
      cantidad2: '',
      tipoAguja3: '',
      origen3: '',
      cantidad3: '',
      tipoAguja4: '',
      origen4: '',
      cantidad4: '',
      diametro: '',
      marca: '',
      galga: '',
      caracteristicaAdicional: ''
    });
    setEditingId(null);
  };

  const handleOpenNew = () => {
    resetForm();
    setError(null);
    setSuccess(null);
    setOpen(true);
  };

  const handleEdit = (caracteristica) => {
    setForm({
      machineNumber: caracteristica.machineNumber || '',
      tipoMaquina: caracteristica.tipoMaquina || '',
      subtipoMaquina: caracteristica.subtipoMaquina || '',
      potencia: caracteristica.potencia || '',
      proceso: caracteristica.proceso || '',
      modelo: caracteristica.modelo || '',
      tipoAguja1: caracteristica.tipoAguja1 || '',
      origen1: caracteristica.origen1 || '',
      cantidad1: caracteristica.cantidad1 || '',
      tipoAguja2: caracteristica.tipoAguja2 || '',
      origen2: caracteristica.origen2 || '',
      cantidad2: caracteristica.cantidad2 || '',
      tipoAguja3: caracteristica.tipoAguja3 || '',
      origen3: caracteristica.origen3 || '',
      cantidad3: caracteristica.cantidad3 || '',
      tipoAguja4: caracteristica.tipoAguja4 || '',
      origen4: caracteristica.origen4 || '',
      cantidad4: caracteristica.cantidad4 || '',
      diametro: caracteristica.diametro || '',
      marca: caracteristica.marca || '',
      galga: caracteristica.galga || '',
      caracteristicaAdicional: caracteristica.caracteristicaAdicional || ''
    });
    setEditingId(caracteristica._id);
    setError(null);
    setSuccess(null);
    setOpen(true);
  };

  const handleSave = async () => {
    setError(null);
    setSuccess(null);

    console.log('Datos del formulario a guardar:', form);

    // Validar campos obligatorios
    if (!form.machineNumber) {
      alert('El número de máquina es obligatorio');
      return;
    }
    if (!form.modelo) {
      alert('El modelo es obligatorio');
      return;
    }
    if (!form.marca) {
      alert('La marca es obligatoria');
      return;
    }
    if (!form.diametro) {
      alert('El diámetro es obligatorio');
      return;
    }
    if (!form.galga || form.galga <= 0) {
      alert('La galga es obligatoria y debe ser mayor a 0');
      return;
    }
    if (!form.tipoAguja1) {
      alert('El tipo de aguja 1 es obligatorio');
      return;
    }
    if (!form.cantidad1 || form.cantidad1 <= 0) {
      alert('La cantidad para tipo de aguja 1 es obligatoria y debe ser mayor a 0');
      return;
    }

    const token = localStorage.getItem('token');
    const headers = {
      'Content-Type': 'application/json',
      ...(token && { 'Authorization': `Bearer ${token}` })
    };

    try {
      const url = editingId
        ? `/api/caracteristicas-maquina/${editingId}`
        : '/api/caracteristicas-maquina';
      
      const method = editingId ? 'PUT' : 'POST';

      console.log('Enviando petición:', { url, method, data: form });

      const response = await fetch(url, {
        method,
        headers,
        body: JSON.stringify(form)
      });

      console.log('Respuesta recibida:', response.status);

      if (response.ok) {
        setSuccess(editingId ? 'Característica actualizada correctamente' : 'Característica creada correctamente');
        setTimeout(() => setSuccess(null), 3000);
        setOpen(false);
        resetForm();
        fetchCaracteristicas();
      } else {
        const errorData = await response.json();
        console.error('Error del servidor:', errorData);
        if (response.status === 400) {
          alert('No puede inscribir una máquina que ya está listada');
        } else {
          alert(`Error ${response.status}: ${errorData.message || 'Error desconocido'}`);
        }
      }
    } catch (err) {
      console.error('Error al guardar:', err);
      alert('Error de conexión al servidor: ' + err.message);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Está seguro de eliminar esta característica?')) return;

    try {
      const token = localStorage.getItem('token');
      const headers = token ? { 'Authorization': `Bearer ${token}` } : {};

      const response = await fetch(`/api/caracteristicas-maquina/${id}`, {
        method: 'DELETE',
        headers
      });

      if (response.ok) {
        setSuccess('Característica eliminada correctamente');
        setTimeout(() => setSuccess(null), 3000);
        fetchCaracteristicas();
      } else {
        const errorData = await response.json();
        alert(`Error al eliminar: ${errorData.message || 'Error desconocido'}`);
      }
    } catch (err) {
      alert('Error de conexión al servidor');
    }
  };

  return (
    <Container maxWidth="xl" sx={{ p: 3 }}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography variant="h4" sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>
          Características Agujas Tejeduria
        </Typography>
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenNew}
          sx={{
            backgroundColor: '#4caf50',
            color: '#0a0a0aff',
            fontFamily: 'Roboto',
            fontWeight: 300,
            '&:hover': { backgroundColor: '#45a049' }
          }}
        >
          Nueva Inscripcion
        </Button>
      </Box>

      {error && <Alert severity="error" sx={{ mb: 2, fontFamily: 'Roboto', fontWeight: 200 }} onClose={() => setError(null)}>{error}</Alert>}
      {success && <Alert severity="success" sx={{ mb: 2, fontFamily: 'Roboto', fontWeight: 200 }} onClose={() => setSuccess(null)}>{success}</Alert>}

      {/* Tabla de características */}
      <TableContainer component={Paper} sx={{ backgroundColor: '#2a2a2a' }}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#1a1a1a' }}>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Máquina</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Tipo</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Subtipo</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Modelo</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Marca</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>Diámetro</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>AGUJAS1</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>AGUJAS2</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>AGUJAS3</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>AGUJAS4</TableCell>
              <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }} align="center">Acciones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {caracteristicas.length === 0 ? (
              <TableRow>
                <TableCell colSpan={11} align="center" sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200, py: 3 }}>
                  No hay características registradas
                </TableCell>
              </TableRow>
            ) : (
              caracteristicas.map((car, index) => (
                <TableRow
                  key={car._id}
                  sx={{
                    '&:hover': { backgroundColor: '#3a3a3a' },
                    backgroundColor: index % 2 === 0 ? '#2a2a2a' : '#323232'
                  }}
                >
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.machineNumber}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.tipoMaquina}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.subtipoMaquina}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.modelo}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.marca}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>{car.diametro}</TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>
                    {car.tipoAguja1 ? `${car.tipoAguja1}${car.origen1 ? ' / ' + car.origen1 : ''}${car.cantidad1 ? ' (' + car.cantidad1 + ')' : ''}` : '-'}
                  </TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>
                    {car.tipoAguja2 ? `${car.tipoAguja2}${car.origen2 ? ' / ' + car.origen2 : ''}${car.cantidad2 ? ' (' + car.cantidad2 + ')' : ''}` : '-'}
                  </TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>
                    {car.tipoAguja3 ? `${car.tipoAguja3}${car.origen3 ? ' / ' + car.origen3 : ''}${car.cantidad3 ? ' (' + car.cantidad3 + ')' : ''}` : '-'}
                  </TableCell>
                  <TableCell sx={{ color: '#fff', fontFamily: 'Roboto', fontWeight: 200 }}>
                    {car.tipoAguja4 ? `${car.tipoAguja4}${car.origen4 ? ' / ' + car.origen4 : ''}${car.cantidad4 ? ' (' + car.cantidad4 + ')' : ''}` : '-'}
                  </TableCell>
                  <TableCell align="center">
                    <Tooltip title="Editar">
                      <IconButton onClick={() => handleEdit(car)} sx={{ color: '#4caf50' }} size="small">
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Eliminar">
                      <IconButton onClick={() => handleDelete(car._id)} sx={{ color: '#f44336' }} size="small">
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Dialog para crear/editar */}
      <Dialog open={open} onClose={() => setOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ backgroundColor: '#1a1a1a', color: '#fff', fontFamily: 'Roboto', fontWeight: 300 }}>
          {editingId ? 'Editar Característica' : 'Nueva Característica'}
        </DialogTitle>
        <DialogContent sx={{ backgroundColor: '#2a2a2a', pt: 2 }}>
          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          
          <Grid container spacing={2}>
            {/* Número de máquina */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1 }}>
                Máquina
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <TextField
                select
                label="Número de Máquina *"
                value={form.machineNumber}
                onChange={(e) => handleChange('machineNumber', e.target.value)}
                fullWidth
                required
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              >
                <MenuItem value=""><em>Seleccione una máquina</em></MenuItem>
                {maquinas
                  .filter(m => {
                    // Filtrar solo máquinas que tienen tipo TEJEDURIA
                    const tipoMaquina = tiposMaquina.find(t => t.machineNumber === m.machineNumber);
                    return tipoMaquina && tipoMaquina.tipoMaquina === 'TEJEDURIA';
                  })
                  .map((m) => (
                    <MenuItem key={m._id} value={m.machineNumber}>
                      Máquina {m.machineNumber} - {m.machine}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>

            {/* Datos de Tipo de Máquina */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1 }}>
                Datos de Tipo de Máquina
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Tipo de Máquina"
                value={form.tipoMaquina}
                fullWidth
                disabled
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
                  '& .Mui-disabled': { color: '#aaa', WebkitTextFillColor: '#aaa' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Subtipo de Máquina"
                value={form.subtipoMaquina}
                fullWidth
                disabled
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
                  '& .Mui-disabled': { color: '#aaa', WebkitTextFillColor: '#aaa' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Potencia"
                value={form.potencia}
                fullWidth
                disabled
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
                  '& .Mui-disabled': { color: '#aaa', WebkitTextFillColor: '#aaa' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Proceso"
                value={form.proceso}
                fullWidth
                disabled
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' },
                  '& .Mui-disabled': { color: '#aaa', WebkitTextFillColor: '#aaa' }
                }}
              />
            </Grid>

            {/* Información general */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1, mt: 2 }}>
                Información General
              </Typography>
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Modelo *"
                value={form.modelo}
                onChange={(e) => handleChange('modelo', e.target.value)}
                fullWidth
                required
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Marca"
                value={form.marca}
                onChange={(e) => handleChange('marca', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Diámetro"
                value={form.diametro}
                onChange={(e) => handleChange('diametro', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={3}>
              <TextField
                label="Galga *"
                type="number"
                value={form.galga}
                onChange={(e) => handleChange('galga', e.target.value)}
                fullWidth
                required
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>

            {/* Agujas 1 */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1, mt: 2 }}>
                Agujas 1
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Tipo de Aguja 1"
                value={form.tipoAguja1}
                onChange={(e) => handleChange('tipoAguja1', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Origen 1"
                value={form.origen1}
                onChange={(e) => handleChange('origen1', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Cantidad 1"
                type="number"
                value={form.cantidad1}
                onChange={(e) => handleChange('cantidad1', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>

            {/* Agujas 2 */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1, mt: 2 }}>
                Agujas 2
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Tipo de Aguja 2"
                value={form.tipoAguja2}
                onChange={(e) => handleChange('tipoAguja2', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Origen 2"
                value={form.origen2}
                onChange={(e) => handleChange('origen2', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Cantidad 2"
                type="number"
                value={form.cantidad2}
                onChange={(e) => handleChange('cantidad2', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>

            {/* Agujas 3 */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1, mt: 2 }}>
                Agujas 3
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Tipo de Aguja 3"
                value={form.tipoAguja3}
                onChange={(e) => handleChange('tipoAguja3', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Origen 3"
                value={form.origen3}
                onChange={(e) => handleChange('origen3', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Cantidad 3"
                type="number"
                value={form.cantidad3}
                onChange={(e) => handleChange('cantidad3', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>

            {/* Agujas 4 */}
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ color: '#4caf50', fontFamily: 'Roboto', fontWeight: 300, mb: 1, mt: 2 }}>
                Agujas 4
              </Typography>
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Tipo de Aguja 4"
                value={form.tipoAguja4}
                onChange={(e) => handleChange('tipoAguja4', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Origen 4"
                value={form.origen4}
                onChange={(e) => handleChange('origen4', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                label="Cantidad 4"
                type="number"
                value={form.cantidad4}
                onChange={(e) => handleChange('cantidad4', e.target.value)}
                fullWidth
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>

            {/* Característica adicional */}
            <Grid item xs={12}>
              <TextField
                label="Característica Adicional"
                value={form.caracteristicaAdicional}
                onChange={(e) => handleChange('caracteristicaAdicional', e.target.value)}
                fullWidth
                multiline
                rows={3}
                sx={{
                  '& .MuiInputLabel-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiInputBase-root': { color: '#fff', fontFamily: 'Roboto', fontWeight: 200 },
                  '& .MuiOutlinedInput-notchedOutline': { borderColor: '#555' }
                }}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ backgroundColor: '#2a2a2a', px: 3, pb: 2 }}>
          <Button
            onClick={() => setOpen(false)}
            sx={{
              color: '#fff',
              borderColor: '#555',
              fontFamily: 'Roboto',
              fontWeight: 200
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleSave}
            variant="contained"
            sx={{
              backgroundColor: '#4caf50',
              color: '#0a0a0aff',
              fontFamily: 'Roboto',
              fontWeight: 300,
              '&:hover': { backgroundColor: '#45a049' }
            }}
          >
            Guardar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default CaracteristicasMaquinas;
